import React, {PureComponent} from 'react';
import MenuIcon from 'mdi-react/MenuIcon';
import {changeSidebarVisibility, changeMobileSidebarVisibility} from '../../../redux/actions/sidebarActions';
import {connect} from 'react-redux';
import '../../../scss/component/topbarSidebarButton.scss';

class TopbarSidebarButton extends PureComponent {
  
  changeSidebarVisibility = () => {
    if(window.screen.width > 1024){
      window.localStorage.getItem('sideBar') ? 
      window.localStorage.removeItem('sideBar') :
      window.localStorage.setItem('sideBar', 'collapsed')
    }
    this.props.dispatch(changeSidebarVisibility());
  };
  
  changeMobileSidebarVisibility = () => {
    this.props.dispatch(changeMobileSidebarVisibility());
  };
  
  render() {
    return (
      <div id="hamburger">
        <button id="desktop" className='topbar__button topbar__button--desktop' onClick={this.changeSidebarVisibility}>
          <MenuIcon className='topbar__button-icon'/>
        </button>
        <button id="mobile" className='topbar__button topbar__button--mobile' onClick={this.changeMobileSidebarVisibility}>
          <MenuIcon className='topbar__button-icon'/>
        </button>
        <span id="company">{this.props.company}</span>
      </div>
    )
  }
}

export default connect(state => {
  return {sidebar: state.sidebar};
})(TopbarSidebarButton);



// WEBPACK FOOTER //
// ./src/pages/_layout/topbar/TopbarSidebarButton.js